import React, { useState, useEffect } from 'react';
import './ClickHandlerWithLoaderContainer.scss';
import Loader from '../Loader';
import { openPopup } from 'qs-utils';

export default ({ linkProps = {}, clickProps = {}, type, classForContainer = '', children }) => {
  const [showLoader, toggleLoader] = useState(false);

  const linkUrlExists = function() {
    if (linkProps.linkUrl !== undefined && linkProps.linkUrl !== null) {
      return true;
    }
    return false;
  };

  useEffect(() => {
    if (showLoader && linkUrlExists()) {
      toggleLoader(false);
      openPopup(linkProps.linkUrl, 'noopener=true');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showLoader, linkProps]);

  const handleRowClick = function(event) {
    event.preventDefault();
    const { clickParams, clickHandler } = clickProps;
    if (clickHandler) {
      clickHandler(clickParams);
    }
    if (type === 'link') {
      if (!linkUrlExists()) {
        toggleLoader(true);
        return;
      }
      openPopup(linkProps.linkUrl, 'noopener=true');
    }
  };

  return (
    <div className={`qs-click-handler--container ${classForContainer}`} onClick={handleRowClick}>
      <div className="qs-click-handler__children--container">{children}</div>
      {showLoader && (
        <div className="qs-click-handler__loader-container">
          <Loader size="small" />
        </div>
      )}
    </div>
  );
};
